/**
 * EMOTO Contact Seller Modal & Inquiry Submission
 */
(function() {
  function initContactSeller() {
    const modal = document.getElementById('emoto-contact-modal');
    if (!modal) return;

    const contactButtons = document.querySelectorAll('[data-contact-seller]');
    const closeButtons = modal.querySelectorAll('[data-close-contact-modal]');
    const form = document.getElementById('emoto-contact-seller-form');
    const formView = document.getElementById('emoto-contact-form-view');
    const successView = document.getElementById('emoto-contact-success-view');
    const submitBtn = document.getElementById('emoto-contact-submit');
    const messageInput = document.getElementById('emoto-buyer-message');
    const pillButtons = modal.querySelectorAll('.emoto-pill-btn');

    const API_ENDPOINT = window.EMOTO_API_BASE 
      ? `${window.EMOTO_API_BASE}/api/inquiries` 
      : 'https://emoto-marketplace-app.vercel.app/api/inquiries';

    // Open Modal
    function openModal() {
      const activeModal = document.getElementById('emoto-contact-modal');
      if (!activeModal) {
        console.warn('[Contact Seller] Modal element #emoto-contact-modal not found in DOM');
        return;
      }
      activeModal.classList.add('is-active');
      const loadedInput = document.getElementById('emoto-form-loaded-at');
      if (loadedInput && !loadedInput.value) loadedInput.value = Date.now();
      activeModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      // Focus first field
      const nameInput = document.getElementById('emoto-buyer-name');
      if (nameInput) setTimeout(() => nameInput.focus(), 100);
    }

    // Expose globally for inline onclick or console debugging
    window.openContactSellerModal = openModal;
    window.closeContactSellerModal = closeModal;

    // Close Modal
    function closeModal() {
      const activeModal = document.getElementById('emoto-contact-modal');
      if (!activeModal) return;
      activeModal.classList.remove('is-active');
      activeModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Direct event listener
    contactButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openModal();
      });
    });

    // Document-level event delegation (catches clicks even if rendered dynamically or deferred)
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-contact-seller]');
      if (btn) {
        e.preventDefault();
        openModal();
      }
    });

    closeButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        closeModal();
      });
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) {
        closeModal();
      }
    });

    // Quick Tag Pills
    const selectedTags = [];
    pillButtons.forEach(pill => {
      pill.addEventListener('click', function() {
        const text = this.getAttribute('data-pill-text') || this.textContent.replace('+', '').trim();
        if (!selectedTags.includes(text)) {
          selectedTags.push(text);
          if (messageInput) {
            const currentVal = messageInput.value.trim();
            if (currentVal && !currentVal.includes(text)) {
              messageInput.value = currentVal + ' ' + text;
            } else if (!currentVal) {
              messageInput.value = text;
            }
          }
          this.style.backgroundColor = '#111111';
          this.style.color = '#ffffff';
          this.style.borderColor = '#111111';
        }
      });
    });

    // Form Submission
    if (form) {
      form.addEventListener('submit', async function(e) {
        e.preventDefault();

        // Clear previous error states
        modal.querySelectorAll('.emoto-contact-error').forEach(el => {
          el.textContent = '';
          el.classList.remove('is-visible');
        });

        const nameInput = document.getElementById('emoto-buyer-name');
        const emailInput = document.getElementById('emoto-buyer-email');
        const phoneInput = document.getElementById('emoto-buyer-phone');
        const timeframeInput = document.getElementById('emoto-visit-timeframe');
        const termsInput = document.getElementById('emoto-buyer-terms');

        let hasError = false;

        if (!nameInput || !nameInput.value.trim()) {
          const err = document.getElementById('err-buyer-name');
          if (err) { err.textContent = 'Please enter your name'; err.classList.add('is-visible'); }
          hasError = true;
        }

        const emailVal = emailInput ? emailInput.value.trim() : '';
        if (!emailVal || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
          const err = document.getElementById('err-buyer-email');
          if (err) { err.textContent = 'Please enter a valid email address'; err.classList.add('is-visible'); }
          hasError = true;
        }

        const msgVal = messageInput ? messageInput.value.trim() : '';
        if (!msgVal) {
          const err = document.getElementById('err-buyer-message');
          if (err) { err.textContent = 'Please include a message for the seller'; err.classList.add('is-visible'); }
          hasError = true;
        }

        if (termsInput && !termsInput.checked) {
          const err = document.getElementById('err-buyer-terms');
          if (err) { err.textContent = 'You must accept the Buyer Terms to proceed'; err.classList.add('is-visible'); }
          hasError = true;
        }

        if (hasError) return;

        // Set Loading State
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.innerHTML = '<span>Sending message...</span>';
        }

        const payload = {
          listing_code: modal.getAttribute('data-listing-code') || '',
          listing_id: modal.getAttribute('data-listing-id') || '',
          buyer_name: nameInput.value.trim(),
          buyer_email: emailVal,
          buyer_phone: phoneInput ? phoneInput.value.trim() : '',
          visit_timeframe: timeframeInput ? timeframeInput.value : 'This weekend',
          message: msgVal,
          buyer_terms_accepted: true,
          quick_tags: selectedTags,
          emoto_hp_website: (document.getElementById('emoto-hp-website') ? document.getElementById('emoto-hp-website').value : ''),
          form_loaded_at: (document.getElementById('emoto-form-loaded-at') ? document.getElementById('emoto-form-loaded-at').value : ''),
          turnstile_token: (typeof window.turnstile !== 'undefined' ? (window.turnstile.getResponse ? window.turnstile.getResponse() : '') : ''),
        };

        try {
          const res = await fetch(API_ENDPOINT, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
            body: JSON.stringify(payload),
          });

          let data = {};
          const contentType = res.headers.get('content-type') || '';
          if (contentType.includes('application/json')) {
            data = await res.json();
          } else {
            const textErr = await res.text();
            console.error('[API Non-JSON Response]', textErr);
            throw new Error('Unable to send inquiry at this moment. Please try again later.');
          }

          if (!res.ok || !data.success) {
            throw new Error(data.error || 'Unable to send message. Please try again.');
          }

          // Show Success View
          if (formView && successView) {
            formView.style.display = 'none';
            successView.style.display = 'block';

            // Populate seller details
            const seller = data.seller || {};
            const sellerNameEl = document.getElementById('emoto-seller-res-name');
            const sellerPhoneRow = document.getElementById('emoto-seller-row-phone');
            const sellerPhoneLink = document.getElementById('emoto-seller-res-phone');
            const sellerEmailRow = document.getElementById('emoto-seller-row-email');
            const sellerEmailLink = document.getElementById('emoto-seller-res-email');

            if (sellerNameEl) sellerNameEl.textContent = seller.name || 'Seller';

            if (seller.phone && sellerPhoneRow && sellerPhoneLink) {
              sellerPhoneLink.textContent = seller.phone;
              sellerPhoneLink.href = `tel:${seller.phone.replace(/\D/g, '')}`;
              sellerPhoneRow.style.display = 'flex';
            }

            if (seller.email && sellerEmailRow && sellerEmailLink) {
              sellerEmailLink.textContent = seller.email;
              sellerEmailLink.href = `mailto:${seller.email}`;
              sellerEmailRow.style.display = 'flex';
            }
          }
        } catch (err) {
          console.error('[Contact Seller Error]', err);
          alert(err.message || 'Failed to send inquiry to the seller. Please try again.');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = '<span>Send to seller</span>';
          }
        }
      });
    }
  }

  /**
   * Save Listing (Watchlist / Wishlist) Controller
   */
  function initSaveListing() {
    const saveBtns = document.querySelectorAll('[data-save-listing]');
    if (!saveBtns.length) return;

    const LOCAL_SAVED_KEY = 'emoto_saved_listings';
    const API_ENDPOINT = window.EMOTO_API_BASE 
      ? `${window.EMOTO_API_BASE}/api/sellers` 
      : 'https://emoto-marketplace-app.vercel.app/api/sellers';

    function getLocalSavedIds() {
      try {
        const raw = localStorage.getItem(LOCAL_SAVED_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch {
        return [];
      }
    }

    function setLocalSavedIds(ids) {
      try {
        localStorage.setItem(LOCAL_SAVED_KEY, JSON.stringify(ids));
      } catch {}
    }

    function getUserEmail() {
      if (window.EMOTO_USER_EMAIL && window.EMOTO_USER_EMAIL.includes('@')) {
        return window.EMOTO_USER_EMAIL;
      }
      try {
        const sessionRaw = localStorage.getItem('emoto_seller_session');
        if (sessionRaw) {
          const session = JSON.parse(sessionRaw);
          if (session && session.email) return session.email;
        }
      } catch {}
      return null;
    }

    saveBtns.forEach(btn => {
      const listingId = btn.getAttribute('data-listing-id') || '';
      const listingCode = btn.getAttribute('data-listing-code') || '';
      const productId = btn.getAttribute('data-product-id') || '';
      const productHandle = btn.getAttribute('data-product-handle') || '';
      const primaryKey = listingId || listingCode || productId;

      if (!primaryKey) return;

      const localSaved = getLocalSavedIds();
      const isSaved = localSaved.some(id => 
        id === primaryKey || 
        (listingId && id === listingId) || 
        (listingCode && id === listingCode) || 
        (productId && id === productId)
      );

      updateSaveBtnUI(btn, isSaved);

      btn.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopPropagation();

        const currentSaved = getLocalSavedIds();
        const currentlySaved = currentSaved.some(id => 
          id === primaryKey || 
          (listingId && id === listingId) || 
          (listingCode && id === listingCode) || 
          (productId && id === productId)
        );
        const nowSaved = !currentlySaved;

        let updatedSaved = [];
        if (nowSaved) {
          updatedSaved = [...currentSaved.filter(id => 
            id !== primaryKey && 
            id !== listingId && 
            id !== listingCode && 
            id !== productId
          ), primaryKey];
        } else {
          updatedSaved = currentSaved.filter(id => 
            id !== primaryKey && 
            id !== listingId && 
            id !== listingCode && 
            id !== productId
          );
        }
        setLocalSavedIds(updatedSaved);
        updateSaveBtnUI(btn, nowSaved);

        // Micro pop animation
        btn.classList.add('pop-anim');
        setTimeout(() => btn.classList.remove('pop-anim'), 350);

        // Sync with backend if user has known email / session
        const email = getUserEmail();
        if (email) {
          try {
            await fetch(API_ENDPOINT, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                action_type: 'toggle_saved_listing',
                email: email,
                listing_id: primaryKey,
                listing_code: listingCode,
                product_id: productId,
                product_handle: productHandle,
                save: nowSaved,
              }),
            });
          } catch (syncErr) {
            console.warn('[Save Listing] Sync warning:', syncErr);
          }
        }
      });
    });

    function updateSaveBtnUI(btn, isSaved) {
      const textSpan = btn.querySelector('.emoto-mp-save-text') || btn.querySelector('span');
      const svg = btn.querySelector('svg');

      if (isSaved) {
        btn.classList.add('is-saved');
        if (textSpan) textSpan.textContent = 'Saved';
        if (svg) {
          svg.setAttribute('fill', '#C4293D');
          svg.setAttribute('stroke', '#C4293D');
        }
      } else {
        btn.classList.remove('is-saved');
        if (textSpan) textSpan.textContent = 'Save';
        if (svg) {
          svg.setAttribute('fill', 'none');
          svg.setAttribute('stroke', 'currentColor');
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initContactSeller();
      initSaveListing();
    });
  } else {
    initContactSeller();
    initSaveListing();
  }
})();
